const QRCodeAPIBaseURL = 'https://api.qrserver.com/v1/create-qr-code/?size=500x500&margin=40&data=';
const barcodeAPIBaseURL = 'http://www.barcodes4.me/barcode/c39/';

export function getGuestIdFormatValue(value) {
  return `EVENTOR:GSTID:${value};`;
}

export function getQRCodeURL({ value, defaultGuestIdFormat = false }) {
  let QRCodeData = value;

  if (defaultGuestIdFormat) QRCodeData = getGuestIdFormatValue(value);
  return `${QRCodeAPIBaseURL}${QRCodeData}`;
}

export function getBarcodeURL(value) {
  return `${barcodeAPIBaseURL}${value}.png`;
}
